import { createAction, createReducer } from '@reduxjs/toolkit';

import {
  FETCH_COUNTRIES_REQUEST,
  FETCH_COUNTRIES_SUCCESS,
  FETCH_COUNTRIES_FAILURE,
  RESET_COUNTRIES_FAILURE,
} from '../actions/fetchCountriesActions';

export const initialState = {
  items: {
    alpha3: [],
  },
  loading: false,
  error: null,
};

const fetchCountriesRequest = state => ({
  ...state,
  loading: true,
  error: null,
});

const fetchCountriesSuccess = (state, action) => ({
  ...state,
  items: { alpha3: action.payload },
  loading: false,
});

const fetchCountriesFailure = (state, action) => ({
  ...state,
  items: { alpha3: [] },
  loading: false,
  error: action.payload,
});

const resetCountriesFailure = state => ({
  ...state,
  error: null,
});

const countries = createReducer(initialState, builder => {
  builder
    .addCase(createAction(FETCH_COUNTRIES_REQUEST), fetchCountriesRequest)
    .addCase(createAction(FETCH_COUNTRIES_SUCCESS), fetchCountriesSuccess)
    .addCase(createAction(FETCH_COUNTRIES_FAILURE), fetchCountriesFailure)
    .addCase(createAction(RESET_COUNTRIES_FAILURE), resetCountriesFailure);
});

export default countries;
